import React, { Component } from "react";
import { Helmet } from "react-helmet";
import logo from "../../assets/logo.png";
import Header from "../HeaderSection/Header";
import BottomBar from "../BottomBar/BottomBar";
import FeatureSection from "./FeatureOne";
import Breadcrumb from "../Blogs/Breadcrumb";
import Navbar from "../Navbar/Navbar";
class Features extends Component {
  render() {
    return (
      <div id="features-page" className="main">
        <Helmet>
          <title>Features | MoneyMonk - Digital Lending Platform</title>
          <meta name="description" content="Explore MoneyMonk's features: instant personal loans, fully digital process, flexible repayment options, and more — available on Android." />
          <link rel="canonical" href="https://moneymonkapp.in/features" />
        </Helmet>
        {/* <Header imageData={"/img/logo-white.png"} /> */}
        <Navbar imageData={logo} />
        {/* <Breadcrumb title="Features" /> */}
        <FeatureSection />
        <BottomBar />
      </div>
    );
  }
}

export default Features;
